import { PageLayout } from '@ipfabric/ui-components/PageLayout/PageLayout';
import { createEnumColumn } from '@ipfabric/utils';
import { ApiTablePage } from 'components/ApiTablePage/ApiTablePage';
import { ButtonLink } from 'components/Button/ButtonLink';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { useLocale } from 'containers/App/LocaleContext';
import { DownloadCliLog } from 'containers/DownloadCliLog/DownloadCliLog';
import type { FC } from 'react';
import { exceptionsTypesByKey } from 'translations/exceptions';
import { useSnapshotId } from 'utils/hooks/useSnapshotId';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';

export const SnapshotManagementErrorsPage: FC = () => {
  const errorsMsg = useLocale().snapshotManagementErrors;
  const endpoint = useTableEndpoint({
    apiEndpoint: '/tables/reports/discovery-errors',
    alternative: (origEndpoint) => ({
      id: origEndpoint.id,
      columns: [
        ...origEndpoint.columns.map((column) =>
          column.key === 'errorType'
            ? createEnumColumn({
                // Keep as text in API, create enum column in frontend
                // to keep single source of truth for error types dictionary.
                // Can be done better, e.g. implement dictionaries to OAS,
                // but not worthy the effort now.
                key: 'errorType',
                title: column.title,
                options: exceptionsTypesByKey,
              })
            : column,
        ),
        createFrontendOnlyColumn({
          key: 'action',
          disabledSort: true,
          title: errorsMsg.actionColumnTitle,
          webDependencies: ['id', 'loginIp'],
          render: (rowData) =>
            rowData.hasLogFile && (
              <DownloadCliLog
                btnText={errorsMsg.btnShowLog}
                collection='error'
                dataKey={rowData.id}
                fileName={`${rowData.loginIp}_${rowData.id}`}
              />
            ),
        }),
      ],
    }),
  });

  const selectedSnapshotId = useSnapshotId();

  return (
    <PageLayout className='flex flex-col' noPadding>
      <div className='m-4'>
        <ButtonLink
          variant='secondary'
          to={
            selectedSnapshotId
              ? `/snapshot-management/${selectedSnapshotId}#errorsSummaryTab`
              : '/snapshot-management/new'
          }
        >
          Back
        </ButtonLink>
      </div>
      <ApiTablePage
        tableClassName='border-t border-default'
        endpoint={endpoint}
      />
    </PageLayout>
  );
};
